import { render } from "./IndividualProduct.vue?vue&type=template&id=cb176810&scoped=true&ts=true"
import script from "./IndividualProduct.vue?vue&type=script&lang=ts"
export * from "./IndividualProduct.vue?vue&type=script&lang=ts"

import "./IndividualProduct.vue?vue&type=style&index=0&id=cb176810&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb176810"]])

export default __exports__